import script from "./AccountTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountTags.vue?vue&type=script&setup=true&lang=ts"

import "./AccountTags.vue?vue&type=style&index=0&id=09743cb4&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09743cb4"]])

export default __exports__